/* ============================================================
   CHICKS UI — La calle Chicks (`<ck-calle>`)
   - `data-activo`: qué tienda rebota y tiene el rótulo en lima.
   - Teléfono: el riel se desliza; al soltarlo, la parada más cercana
     queda activa. Puntos y rótulos llevan el riel a su tienda.
   - Avanza solo cada 3.2 s mientras se ve y nadie lo ha tocado.
   - Pausa las animaciones del SVG fuera de pantalla o con menos
     movimiento pedido.
   ============================================================ */

(function () {
  'use strict';
  if (customElements.get('ck-calle')) return;

  var CENTROS = [220, 560, 905, 1240]; // x de cada tienda en el dibujo de 1440

  class CkCalle extends HTMLElement {
    connectedCallback() {
      this.riel = this.querySelector('[data-ck-riel]');
      this.escena = this.querySelector('.ck-calle__escena');
      this.svg = this.querySelector('svg');
      this.tiendas = [].slice.call(this.querySelectorAll('[data-ck-tienda]'));
      this.puntos = [].slice.call(this.querySelectorAll('.ck-calle__punto'));
      this.quieto = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.tel = window.matchMedia('(max-width: 640px)');
      this.tocado = false;
      this.propio = 0;

      this.classList.add('ck-calle--viva');
      this.querySelector('.ck-calle__puntos').hidden = false;
      if (this.quieto && this.svg) this.svg.pauseAnimations();

      this.addEventListener('click', (e) => {
        var b = e.target.closest('[data-ck-ir]');
        if (!b) return;
        this.soltar();
        this.activar(+b.dataset.ckIr, true);
      });
      this.tiendas.forEach((t, i) => {
        var ir = () => { if (!this.tel.matches) { this.soltar(); this.activar(i); } };
        t.addEventListener('pointerenter', ir);
        t.addEventListener('focus', ir);
      });

      var parar = () => this.soltar();
      this.riel.addEventListener('pointerdown', parar, { passive: true });
      this.riel.addEventListener('wheel', parar, { passive: true });
      this.riel.addEventListener('touchstart', parar, { passive: true });
      var espera;
      this.riel.addEventListener('scroll', () => {
        if (!this.tel.matches || performance.now() < this.propio) return;
        clearTimeout(espera);
        espera = setTimeout(() => this.activar(this.cercana()), 90);
      }, { passive: true });

      this.vista = new IntersectionObserver((e) => {
        this.dentro = e[0].isIntersecting;
        if (this.svg && !this.quieto) this.dentro ? this.svg.unpauseAnimations() : this.svg.pauseAnimations();
      });
      this.vista.observe(this);

      if (!this.quieto) {
        this.reloj = setInterval(() => {
          if (this.dentro && !this.tocado) this.activar((this.activo + 1) % this.tiendas.length, true);
        }, 3200);
      }
      this.activo = 0;
    }

    disconnectedCallback() {
      clearInterval(this.reloj);
      if (this.vista) this.vista.disconnect();
    }

    soltar() {
      this.tocado = true;
      clearInterval(this.reloj);
    }

    parada(i) {
      var escala = this.escena.offsetWidth / 1440;
      var max = this.riel.scrollWidth - this.riel.clientWidth;
      return Math.max(0, Math.min(max, CENTROS[i] * escala - this.riel.clientWidth / 2));
    }

    cercana() {
      var x = this.riel.scrollLeft;
      var mejor = 0;
      for (var i = 1; i < this.tiendas.length; i++) {
        if (Math.abs(this.parada(i) - x) < Math.abs(this.parada(mejor) - x)) mejor = i;
      }
      return mejor;
    }

    activar(i, mover) {
      this.activo = i;
      this.dataset.activo = i;
            this.puntos.forEach((p, n) => p.setAttribute('aria-pressed', n === i ? 'true' : 'false'));
      if (mover && this.tel.matches) {
        // El scroll que hacemos nosotros no cuenta como gesto ni recalcula la parada.
        this.propio = performance.now() + 900;
        this.riel.scrollTo({ left: this.parada(i), behavior: this.quieto ? 'auto' : 'smooth' });
      }
    }
  }

  customElements.define('ck-calle', CkCalle);
})();
